module.exports = __webpack_public_path__ + "de1369686e344f2916520fdd3451104c.glb";